var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbra3DstWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 574",
    style: {
      enableBackground: "new 0 0 1080 574"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,208.3v-74.7h23.2v73.8c0,24.1,12.6,36.9,33.4,36.9c20.6,0,33.2-12,33.2-35.9v-74.7h23.2v73.6 c0,38.7-22.3,58.2-56.8,58.2C157.4,265.4,135.5,245.9,135.5,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.5,133.6h24.7l40.2,61.3l40.2-61.3h24.7v129.7H411v-93l-41.7,61.1h-0.8l-41.3-60.8v92.6h-22.8 L304.5,133.6L304.5,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.5,133.6h59.2c15.1,0,27,4.1,34.5,11.5c5.8,5.8,8.9,12.8,8.9,21.5v0.4c0,15.6-9,23.9-18.9,28.9 c15.5,5.2,26.2,13.9,26.2,31.5v0.4c0,23.2-19.4,35.6-48.8,35.6h-61.1L494.5,133.6L494.5,133.6z M573.9,170.3 c0-10.2-8.3-16.5-23.2-16.5h-33.4v34.5H549c14.9,0,24.9-5.7,24.9-17.6V170.3z M554.1,207.6h-36.8v35.6h38.5 c15.8,0,25.5-6.1,25.5-17.8V225C581.3,214,572.4,207.6,554.1,207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.1,133.6h58.8c16.6,0,29.6,4.8,38.1,13c7,7,10.9,16.7,10.9,28v0.4c0,21.3-13,34.1-31.3,39.3l35.6,49.1 h-27.5l-32.4-45.2h-29v45.2h-23.2L657.1,133.6L657.1,133.6z M714.2,197.9c16.6,0,27.2-8.5,27.2-21.7v-0.4 c0-13.9-10.2-21.5-27.3-21.5h-33.8v43.6L714.2,197.9L714.2,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M865.9,132.7h21.5l58.1,130.6H921L907.6,232h-62.4l-13.6,31.3h-23.8L865.9,132.7z M899.1,211.8l-22.8-51.9 l-22.6,51.9H899.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,422.4l6.2-5c8.6,10.8,19.4,17,33.6,17c14.5,0,26.7-9.5,26.7-23.5v-0.3c0-14.9-14.2-23-33.6-23h-5.9 l-2-4.4l37.2-42.1H141v-7.4h67.6v5.6L172,380.2c20.5,1.2,38.3,10.6,38.3,30v0.3c0,18.5-16.5,30.9-35.2,30.9 C157.5,441.5,144.3,433.6,135.5,422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.1,333.5h35.9c33.9,0,57.4,22.9,57.4,52.8v0.3c0,29.9-23.4,53.1-57.4,53.1h-35.9V333.5z M242.2,340.8 v91.6h27.9c30.1,0,49-20.2,49-45.5v-0.3c0-25.2-19-45.8-49-45.8L242.2,340.8L242.2,340.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.9,424.2l5.2-5.9c11.9,10.8,22.8,15.8,38.7,15.8c16.2,0,27.3-9,27.3-21.1v-0.3c0-11.2-6-17.7-30.5-22.6 c-25.9-5.2-36.4-13.8-36.4-29.9v-0.3c0-15.8,14.6-27.9,34.7-27.9c15.7,0,26.1,4.2,37,12.9l-5.1,6.2c-10.2-8.6-20.4-12-32.2-12 c-15.9,0-26.4,9-26.4,20v0.3c0,11.2,5.9,18,31.5,23.2c25,5,35.5,13.8,35.5,29.3v0.3c0,17.1-15,29-35.8,29 C397.1,441.2,383.8,435.6,370.9,424.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501,340.8h-37.6v-7.3h83.3v7.3H509v98.9h-8L501,340.8L501,340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M566.2,395.5v-62h8v61.3c0,25,13.7,39.4,36.6,39.4c21.9,0,35.9-13,35.9-38.7v-62h8v61.1 c0,30.5-18,46.7-44.3,46.7C584.5,441.3,566.2,425.3,566.2,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M682,333.5h35.9c33.9,0,57.4,22.9,57.4,52.8v0.3c0,29.9-23.4,53.1-57.4,53.1H682V333.5z M690,340.8v91.6 h27.9c30.1,0,49-20.2,49-45.5v-0.3c0-25.2-19-45.8-49-45.8L690,340.8L690,340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802.1,333.5h8v106.1h-8V333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836,386.9v-0.3c0-29,21.8-54.9,54.5-54.9s54.1,25.6,54.1,54.6v0.3c0,29-21.8,54.9-54.5,54.9 C857.5,441.5,836,415.9,836,386.9z M936.3,386.9v-0.3c0-26.2-19.4-47.8-46.1-47.8c-26.7,0-45.8,21.2-45.8,47.5v0.3 c0,26.2,19.4,47.8,46.1,47.8C917.2,434.4,936.3,413.1,936.3,386.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 340.9,
    y: 426.9,
    className: "st0",
    width: 12.9,
    height: 12.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbra3DstWhite);
export default __webpack_public_path__ + "static/media/Umbra3DST-white.a8c7ebed267a82de89911e54107267cd.svg";
export { ForwardRef as ReactComponent };